// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer--37FtP","logo":"logo--dIjIW","info":"info--2xp_U","social":"social--3bb8O","separator":"separator--1YVtg","heading":"heading--3ECw-","sponsors":"sponsors--2B9Ug","sponsorsContainer":"sponsorsContainer--3AsVG","credits":"credits--3WUnU calderDark--1bp9m","venue":"venue--1qD85"};


//////////////////
// WEBPACK FOOTER
// ./components/Footer/styles.css
// module id = 996
// module chunks = 2